var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-create-form',{attrs:{"create-form":_vm.createForm,"formTitle":_vm.formTitle},on:{"submitForm":_vm.submitForm,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }